import TextField from "@mui/material/TextField";
import { FormInputProps } from "../form-input";
import { FormItemLabel } from "./form-item-label";

export type PasswordInputProps = {} & Omit<FormInputProps, "formLayout">;

export const PasswordInput: React.FC<PasswordInputProps> = ({
  formItem,
  formData,
  setValue,
}) => {
  const resolvedValue = (): string => {
    const e = formData[formItem.name];
    if (!e) return "";
    else return e as string;
  };
  return (
    <div className="_password-input.tsx password-input">
      <TextField
        id={formItem.name}
        value={resolvedValue()}
        onChange={(evt) => setValue(evt.target.value)}
        disabled={formItem.disabled}
        type="password"
        fullWidth
        variant="outlined"
        label={
          <FormItemLabel
            label={formItem.label ?? formItem.name}
            helpText={formItem.helpText}
          />
        }
      />
    </div>
  );
};
